import {
  put, call, select, all,
} from 'lib/redux';
import * as types from 'constants/ActionTypes';
import { getInitParametersSaga } from 'features/userData/UserData.saga';
import {
  fetchOrderHistoryReportDetailsSaga, fetchOrderHistoryReportFileTypesSaga,
  fetchAvailableReportActions,
  getAvailableReportActions,
} from 'features/orderHistory/OrderHistory.saga';
import getReportAddressesService from 'services/getReportAddresses.service';
import { logError } from 'utils/logger.utils';

export function* loadReportDetailsSaga({ reportId }) {
  try {
    yield put({ type: types.ORDER_RESET_ERROR });
    yield put({ type: types.LOAD_REPORT_DETAILS_PAGE_LOADING });
    yield call(getInitParametersSaga);

    const { reportDetails, availableActions } = yield all({
      availableActions: fetchAvailableReportActions([reportId]),
      reportDetails: fetchOrderHistoryReportDetailsSaga([reportId]),
    });

    const { loadError } = yield select(({ orderHistory }) => orderHistory);
    if (!loadError) {
      yield all([
        fetchOrderHistoryReportFileTypesSaga(reportDetails),
        availableActions && getAvailableReportActions(reportDetails, [reportId], availableActions),
      ]);
      yield put({ type: types.ORDER_HISTORY_REPORT_IDS_SUCCESS, reportIds: [reportId] });
    } else {
      logError('Failed to load report details', { reportId });
    }
    yield put({ type: types.LOAD_REPORT_DETAILS_PAGE_LOADED });
  } catch (error) {
    logError('Error in loadReportDetailsSaga', {
      error: error.message,
      errorCode: error.errorCode,
      reportId,
    });
    yield put({ type: types.LOAD_REPORT_DETAILS_PAGE_ERROR });
  }
}

export function* loadReportAddressesSaga({ orderId }) {
  try {
    const reportDetails = yield select(({ orderHistory }) => orderHistory.reportDetails);
    const detail = orderId === null
      ? reportDetails[0]
      : reportDetails.find(({ orderId: id }) => Number(id) === Number(orderId)) || reportDetails[0];
    const requestBody = detail.orderId;
    const signature = detail.signedOrderId; // #genai

    const reportAddressesResponse = yield call(getReportAddressesService, requestBody, signature);
    if (!reportAddressesResponse.ok) {
      const error = new Error(reportAddressesResponse.json.errorDescription);
      error.errorCode = reportAddressesResponse.json.errorCode;
      logError('Failed to load report addresses', {
        error: error.message,
        errorCode: error.errorCode,
        orderId: requestBody,
      });
      throw error;
    }
    const reportAddresses = reportAddressesResponse.json;
    yield put({ type: types.ADD_REPORT_ADDRESS_SUCCESS, reportAddresses });
  } catch (err) {
    logError('Error in loadReportAddressesSaga', {
      error: err.message,
      errorCode: err.errorCode,
      orderId,
    });
    yield put({ type: types.ADD_REPORT_ADDRESS_FAILURE });
  }
}
